var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bw-date-picker',{attrs:{"prepend-inner-icon":"","label":"","solo":"","outlined":"","dense":"","value":_vm.date13,"clearable":true},on:{"update:value":function($event){_vm.date13=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }